import type { ReactNode } from 'react';

export interface TweetProps {
  /** link to the post on X */
  url: string;
  author?: string;
  children?: ReactNode;
}

/** A lightweight quote card linking to an X / Twitter post (no external script). */
export const Tweet = ({ url, author, children }: TweetProps) => (
  <figure className="my-6 rounded-10 border border-line bg-surface-2 px-5 py-4">
    <blockquote className="text-15 text-text-2 [&>*:last-child]:mb-0">{children}</blockquote>
    <figcaption className="mt-3 text-13 text-text-3">
      {author ? <span className="text-text-2">{author}</span> : null}
      {author ? ' · ' : null}
      <a href={url} className="text-accent hover:underline" target="_blank" rel="noopener noreferrer">
        View on X
      </a>
    </figcaption>
  </figure>
);
